import CommonText from "@/components/text/CommonText";
import React, { FC, HTMLAttributes, useRef, useEffect, useCallback } from "react";

interface CustomDivProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  setCloseModal: (value: boolean) => void;
  headingText?: string;
  notShowCrossBtn?: boolean;
}

const ModalForMobileNav: FC<CustomDivProps> = ({
  children,
  setCloseModal,
  notShowCrossBtn,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const handleOutsideClick = useCallback((event: MouseEvent | TouchEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      setCloseModal(false);
    }
  }, [setCloseModal]);

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
    
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [handleOutsideClick]);

  return (
    <>
      <div className="fixed inset-0 z-[1000] bg-black/50 flex gap-2 items-center justify-center">
        <div 
          ref={modalRef}
          className="bg-white rounded-2xl w-[300px] h-[80vh] flex flex-col overflow-y-auto"
        >
          {children}
        </div>
        {!notShowCrossBtn && (
          <div className="flex h-[80vh] items-start">
          <button
            onClick={() => {
              setCloseModal(false);
            }}
            className="bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center focus:outline-none cursor-pointer"
            aria-label="Close"
          >
            <CommonText size="xl" className="font-bold mt-[-4px] text-gray-500">
              &times;
            </CommonText>
          </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ModalForMobileNav;
